<template>
  <div class="container lottery2 page">
    <van-nav-bar :title="this.lottery.name" class="nav-bar">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
      <!--      <template #right>-->
      <!--        <div class="right">切换任务</div>-->
      <!--      </template>-->
    </van-nav-bar>
    <div class="record">
      <div class="period ">
        <van-image :src="BASE_URL + lottery.ico" class="cover">
          <template v-slot:loading>
            <van-loading type="spinner"/>
          </template>
        </van-image>
        <span class="period-number">
          <div>{{ $t('本期') }}</div>
          <div>{{ this.lottery.next_expect }}</div>
        </span>
        <div class="next-number">
          <span>{{ $t('剩余时间') }}</span>
          <!-- <span>{{ this.lottery.next_expect }}</span> -->
          <van-count-down :time="time" @finish="check()"/>
        </div>

      </div>
      <!--<div class="linear-gradient"-->
      <!--     style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>-->
      <!-- <div class="kuaisan-ball left recent-card"> -->
        <!--<van-image :src="this.shanzi_1" class="res-img">-->
        <!--  <template v-slot:loading>-->
        <!--    <van-loading type="spinner"/>-->
        <!--  </template>-->
        <!--</van-image>-->
        <!--<van-image :src="this.shanzi_2" class="res-img">-->
        <!--  <template v-slot:loading>-->
        <!--    <van-loading type="spinner"/>-->
        <!--  </template>-->
        <!--</van-image>-->
        <!--<van-image :src="this.shanzi_3" class="res-img">-->
        <!--  <template v-slot:loading>-->
        <!--    <van-loading type="spinner"/>-->
        <!--  </template>-->
        <!--</van-image>-->
        <!-- <div>
          <div class="period-number">{{ this.lottery.now_expect }}</div>
          <div class="period-number">{{ $t('投票结果') }}</div>
        </div>
        <div class="numCard-wrapper">
          <div class="numCard numCard1">{{ this.sum }}</div>
          <div class="mid-num-wrapper">
            <div class="numCard">{{ size }}</div>
            <div class="numCard">{{ double }}</div>
          </div>
          <van-icon :class="{ up: active,down:!active }" name="arrow-down"
                    @click="active ? active = false : active = true"/>
        </div>
      </div> -->

      <!-- 广告轮播 -->
      <div class="carouselAds">
        <!-- 有数据且在 Lottery 路由时显示轮播，分两种布局 -->
        <div v-if="$route.path === '/Lottery' && carouselAds.length > 0" class="carousel-container">
          <!-- 少于3个：使用单页 Swiper（普通轮播），每页展示1个，宽高由容器决定 -->
          <swiper
            v-if="carouselAds.length < 2"
            ref="carouselSingle"
            :options="singleSwiperOption"
            class="carouselAds_swiper single"
            @slideChange="onSlideChange"
          >
            <swiper-slide
              v-for="(v, key) in carouselAds"
              :key="key"
              :class="{ 'active-slide': activeIndex === key }"
            >
              <div class="swiper-lazy-container">
                <img :src="v.url" class="carouselAds_img" />
              </div>
            </swiper-slide>
          </swiper>

          <!-- >=3个：使用 Swiper，选中项通过 activeIndex 放大 -->
          <swiper
            v-else
            ref="carouselSwiper"
            :options="bannerSwiperOption"
            :class="['carouselAds_swiper', 'coverflow']"
            @slideChange="onSlideChange"
          >
            <swiper-slide
              v-for="(v, key) in carouselAds"
              :key="key"
              class="carousel-slide"
              :class="{ 'active-slide': activeIndex === key }"
            >
              <div class="swiper-lazy-container">
                <img :data-src="v.url" class="carouselAds_img swiper-lazy" />
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <!-- 加载或无数据时显示占位 -->
        <div v-else class="carouselAds_swiper loadingBox">
          <van-loading type="circular" size="24px" />
        </div>
      </div>
    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <!--<div class="tips">-->
          <!--  <p class="odds">【{{ this.lottery.desc }}】</p>-->
          <!--  <div class="play-tip">-->
          <!--    <van-icon name="more-o"/>-->
          <!--    &lt;!&ndash;                  <span class="span-text" @click="playgame = true">玩法提示</span>&ndash;&gt;-->
          <!--    <span class="span-text" @click="$router.push({path:'/GameRecord'});">任务记录</span>-->
          <!--    <van-popup v-model="playgame" class="mask" get-container="body">-->
          <!--      <div class="play-type-tip">-->
          <!--        <div class="title">玩法规则</div>-->
          <!--        <div class="wrapper">-->
          <!--          <div class="item">-->
          <!--            <van-icon name="info-o"/>-->
          <!--            <div class="content">-->
          <!--              <p class="content-title">玩法提示</p>-->
          <!--              <p class="content-detail">从可选和值形态里面选择号码进行下注</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="item">-->
          <!--            <van-icon name="comment-o"/>-->
          <!--            <div class="content">-->
          <!--              <p class="content-title">中奖说明</p>-->
          <!--              <p class="content-detail">三个开奖号码总和值11~18 为大;总和值3~ 10为小;</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="item">-->
          <!--            <van-icon name="description"/>-->
          <!--            <div class="content">-->
          <!--              <p class="content-title">投注范例</p>-->
          <!--              <p class="content-detail">投注方案：小 开奖号码：123,即中小</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--      </div>-->
          <!--    </van-popup>-->
          <!--  </div>-->
          <!--</div>-->
          <div class="linear-gradient"
               style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
          <div class="sumValueTwoSides">
            <div v-for="(v,key) in lottery_peilv_list" :key="key" :class="{active:choose[v.type]}"
                 class="rectangle large" @click="choosePlay(v.type,v.name);">
              <div class="wrapper">
                <div class="content bg1" :style="{background: choose[v.type] ? '#f82d46' : ''}">
                  <p class="name-text large"><span class="text-wrapper">{{ v.name }}</span></p>
                  <!--<p class="odd-text large">{{ v.proportion }}</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div class="item" @click="shopping ? shopping = false : shopping = true ">
              <van-icon class="jixuanico" name="cart-o"/>
              <!--<span class="text">任务单</span>-->
            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <span class="text">{{ $t('可用余额') }}</span>
            <span class="text num">{{ this.userInfo.money }}</span>
          </div>
          <div class="right" @click="jiesuan()">
            {{ $t('立即投票') }}
          </div>
        </div>
        <div :class="{active:shopping}" class="wrapper">
          <div class="item">
            <span class="label">{{ $t('当前选号') }}：</span>
            <div class="bet-number">{{ shopchoose === '未选中' || shopchoose === '未选择' ? $t(shopchoose): shopchoose }}</div>
            <van-icon :class="{ up: !shopping,down:shopping }" name="arrow-down"
                      @click="shopping ? shopping = false : shopping = true"/>
          </div>
          <div class="item">
            <span class="label">{{ $t('每注金额') }}：</span>
            <div class="amount-wrapper">
              <van-field v-model="money" :placeholder="$t('请输入金额')" type="digit"/>
            </div>
          </div>
          <div class="item">
            <div class="part">
              <span>{{ $t('总共') }}</span>
              <span class="number">{{ this.formData.length }}</span>
              <span>{{ $t('注') }}</span>
            </div>
            <div class="part">
              <span>{{ $t('合计') }}</span>
              <span class="number">{{ this.formData.length * this.money }}</span>
            </div>

          </div>
        </div>
      </div>
      <van-popup v-model="jiesuanpage" get-container="body">
        <div class="confirm-order-modal">
          <div class="head van-hairline--bottom">
            <p class="text">{{ $t('任务单') }}</p>
          </div>
          <ul class="list">
            <li v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
              <div class="main">
                <p class="bet-name">{{ v.name }}</p>
                <p class="detail-text">{{ $t('1注X{money}元={money}元',{money: money}) }}</p>
              </div>
              <van-icon name="close" @click="clearChooes(v.type)"/>
            </li>
          </ul>
          <div class="sub-bar">
            <van-button class="item cancel-btn" type="default" @click="allClear()">{{ $t('清空订单') }}</van-button>
            <van-button class="item sub-btn" type="default" @click="doSub">{{ $t('确认投票') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="active" :style="{ height: '70%' }" position="top">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight">{{ $t('期号') }}</div>
              <div class="right font-weight">{{ $t('数据') }}</div>
            </div>
            <div v-for="(v,key) in lottery_list" :key="key" class="item">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <span class="res-des middle sum">{{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}</span>
                <div class="kuaisan-ball left">
                  <!--<div class="number">{{ v.opencode[0] }}</div>-->
                  <!--<div class="number">{{ v.opencode[1] }}</div>-->
                  <!--<div class="number number3">{{ v.opencode[2] }}</div>-->


                  <span
                      class="res-des middle">
                    {{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? bigSelectionText : smallSelectionText
                    }}</span>
                  <span
                      class="res-des middle">{{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? doubleSelectionText : oddSelectionText
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      bgList: [
          '/img/option-bg/fb.jpg',
          '/img/option-bg/ig.jpg',
          '/img/option-bg/pb.jpg',
          '/img/option-bg/tk.jpg'
      ],
      bgColorMap: {
        facebook: '#0866FF',
        instagram: '#CD2E8A',
        pornhub: '#EF921C',
        tiktok: '#000000',
      },
      choose: {
        "大": false,
        "小": false,
        "单": false,
        "双": false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      BASE_URL: process.env.VUE_APP_BASE_URL,
      size: "",
      double: "",
      time: 0,
      shopchoose: "未选择",
      gameitem: "",
      formData: [],
      money: "",
      // 轮播配置
      activeIndex: 0,
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        // loop: true,  // 启用循环模式
        autoplay: {
          delay: 3500,            // 3.5秒切换一次
          disableOnInteraction: false, // 用户操作后继续自动播放
          pauseOnMouseEnter: true // 鼠标悬停时暂停
        },
        lazy: {
          loadPrevNext: true,
          loadOnTransitionStart: true,
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
      },
      singleSwiperOption: {
        effect: 'slide',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        speed: 600,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        lazy: false,
      },
      // 暂时写死广告列表
      carouselAds: [
        // { img: '/img/option-bg/fb.jpg',url: 'https://www.google.com.hk/' },
        // { img: '/img/option-bg/ig.jpg',url: 'https://www.google.com.hk/' },
        // { img: '/img/option-bg/pb.jpg',url: 'https://www.google.com.hk/' },
        // { img: '/img/option-bg/tk.jpg',url: 'https://www.google.com.hk/' },
      ],
    };
  },
  computed: {
    bigSelectionText() {
      if (!this.lottery_peilv_list.length) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '大').name
    },
    smallSelectionText() {
      if (!this.lottery_peilv_list.length) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '小').name
    },
    oddSelectionText() {
      if (!this.lottery_peilv_list.length) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '单').name
    },
    doubleSelectionText() {
      if (!this.lottery_peilv_list.length) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '双').name
    },
  },
  methods: {
    getBG(index) {
      if (index>3) {
        return this.bgList[3]
      }
      return this.bgList[index]
    },
    back() {
      return window.history.back();
    },
    //广告调用链接
    openLink(url) {
      window.open(url, '_blank');
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("金额错误") + '！');
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("请选号") +'！');
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("请填写金额") +'！');
        return false;
      } else {
        if (this.userInfo.money - (this.money * this.formData.length) < 0) {
          this.$toast(this.$t("余额不足，请联系客服充值！"));
          return false;
        } else {
          this.$http({
            method: 'post',
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res => {
            if (res.code === 200) {
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          })
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = "未选中";
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("请选号") +'！');
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("请填写金额") +'！');
        return false;
      } else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]['type']) {
          this.formData.splice(i, 1)
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.formData[j]['name'];
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = "未选中";
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]['type']) {
            this.formData.splice(i, 1)
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({'name': name, 'type': type})
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.formData[j]['name'];
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = "未选中";
        this.gameitem = "";
        this.shopping = false;
      }

    },
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0)
        }, 300)
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("刷新成功") + '！');
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    onSlideChange() {
      // 支持 coverflow (carouselSwiper) 与 单页轮播 (carouselSingle)
      if (this.$refs.carouselSwiper && this.$refs.carouselSwiper.swiper) {
        this.activeIndex = this.$refs.carouselSwiper.swiper.realIndex;
        return;
      }
      if (this.$refs.carouselSingle && this.$refs.carouselSingle.swiper) {
        this.activeIndex = this.$refs.carouselSingle.swiper.realIndex;
      }
    },
    selectSimple(index) {
      this.activeIndex = index;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv() {
      this.$http({
        method: 'get',
        data: {id: this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
          console.log("=>(index.vue:447) this.lottery_peilv_list", this.lottery_peilv_list);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList() {
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          console.log("=>(index.vue:487) res.data", res.data);
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getCarouselList() {
      this.$http({
        method: 'get',
        data: {type: 3},
        url: 'lottery_carousel'
      }).then(res => {
        if (res.code === 200) {
          this.carouselAds = res.data;
          console.log("=>(index.vue:558) res.data", res.data);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo() {
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("请联系管理员领取该任务") + '!');
            this.$router.push({path: '/Home'})
            return false;
          }
          this.lottery = res.data;
          console.log("=>(index.vue:470) res.data", res.data);
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("开奖成功，期号：") + this.lottery.now_expect);
          }
          this.shanzi_1 = "img/lottery/shaizi/" + res.data?.opencode[0] + ".png";
          this.shanzi_2 = "img/lottery/shaizi/" + res.data?.opencode[1] + ".png";
          this.shanzi_3 = "img/lottery/shaizi/" + res.data?.opencode[2] + ".png";
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = this.bigSelectionText;
          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = this.smallSelectionText;
          }
          if (this.sum % 2 === 0) {
            this.double = this.doubleSelectionText;
          } else {
            this.double = this.oddSelectionText;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })

    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getLotteryInfo();
      this.getLotteryList();
      this.getCarouselList();//获取轮播广告列表

    }
  },
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.lottery2 {
  background: url("/img/lottery/lotterybg.png") no-repeat top;
  z-index: 10;
  background-size: contain;
}

.lottery2 .van-nav-bar {
  background: linear-gradient(90deg, rgba(126, 86, 120, .8), rgba(230, 195, 161, .8)) !important;
}

.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;
  border: 2px solid #fff;
  line-height: 60px;
}

.record {
  padding-left: 2.667vw;
  padding-right: 2.667vw;
  background: linear-gradient(90deg, rgba(126, 86, 120, .8), rgba(230, 195, 161, .8));
  box-shadow: 0 .533vw .533vw 0 #cacaca;
  z-index: 1;
  padding-bottom: 20px;
}

.record .period {
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.record .period .cover {
  width: 120px;
  height: 120px;
  -o-object-fit: cover;
  object-fit: cover;
}

.record .period .period-number {
  flex: 1;
  margin-left: 20px;
  margin-right: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  color: #fff !important;
  font-weight: bold
}

.carouselAds {
  width: 100%;
  // margin-top: -23%;
  height: 40vw;
}
.carousel-container {
  height: 100%;
}
.simple-layout {
  display: flex;
  gap: 12px;
  height: 100%;
}
.simple-layout .simple-slide {
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform .28s ease, box-shadow .28s ease;
  transform: scale(0.98);
}
.simple-layout .simple-slide.active-slide {
  transform: scale(1.04);
  box-shadow: 0 8px 22px rgba(0,0,0,0.18);
  z-index: 2;
}
.swiper-lazy-container {
    height: 100% !important;
    width: 100%;
  }

.carouselAds_swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }

  .carousel-slide {
    transition: transform .28s ease, box-shadow .28s ease;
    transform: scale(0.94);
  }

  .carousel-slide.active-slide {
    transform: scale(1.06);
    box-shadow: 0 10px 26px rgba(0,0,0,0.18);
    z-index: 3;
  }
}

/* 单页 Swiper（class: single）使每个 slide 填满容器 */
.carouselAds_swiper.single .swiper-slide {
  width: 100% !important;
  height: 100% !important;
}

/* coverflow 模式下固定 slide 尺寸以展示透视效果 */
.carouselAds_swiper.coverflow .swiper-slide {
  width: 620px;
  height: 300px;
}

::v-deep .swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

::v-deep .swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
}

.carouselAds_img {
  border-radius: 12px;
  width: 100%;
  height: 100%;
  // object-fit: cover;
  display: block;
}

.loadingBox {
  background: #f5f5f5;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.period-number {
  text-align: center;
  flex: 1;
  margin-left: 20px;
  margin-right: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  color: #fff !important;
  font-weight: bold
}

.period-number,.next-number {
  display: flex;
  flex-direction: column;
  height: auto !important;
  line-height: unset !important;
  gap: 10px;
}
.period-number div:first-child,.next-number span {
  font-size: 28px !important;
  font-weight: 600 !important;
}

.van-count-down {
  color: #FF253F;
  font-weight: bold;
  font-size: 6vw !important;
  font-size: 45px;
  // margin-top: 10px;
  float: right;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.record .recent {
  display: flex;
  align-items: center;
  height: 110px;
}


.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball .number {
  color: #e6c3a1;
  font-weight: 700;
  margin-right: 1.067vw;
  font-size: 5vw;
}

.kuaisan-ball .number3 {
  margin-right: 4.067vw !important;
}

.kuaisan-ball .sum {
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  color: #fff !important;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  margin-right: 4vw;
  border-radius: 50% !important;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  color: #fff;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  margin-right: 4vw;
  border-radius: 10px;
}

.numCard-wrapper {
  width: 60%;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.numCard {
  width: 80%;
  font-size: 4.667vw;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  color: #fff;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-weight: 700;
  border-radius: 1.333vw;
}

.numCard1 {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border-radius: 50%;
}

.kuaisan-ball .res-des.middle {
  //width: 15%;
  font-size: 35px;
}

.van-icon {
  font-size: 40px;
}

.down {
  transition: all .5s;
}

.up {
  transform: rotate(180deg);
  transition: all .5s;
}

.wrapper {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.options-bar {
  display: flex;
  align-items: center;
  height: calc(100% - 80px);
}

.options-bar .game {
  background-color: #fff;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.options-bar .game .tips {
  display: flex;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.options-bar .game .tips .odds {
  flex: 1;
  font-size: 35px;
  font-weight: 500;
  color: #ff253f;
}

.options-bar .game .tips .play-tip {
  display: flex;
  align-items: center;
  height: 100%;
}

::v-deep .van-icon-more-o {
  color: #ff253f;
  font-size: 50px;
}

.options-bar .game .tips .play-tip .span-text {
  margin-left: 10px;
  font-size: 35px;
  font-weight: bolder;
  color: #ff253f;
}

.linear-gradient {
  width: 100%;
  height: 2px;
}

.sumValueTwoSides {
  display: flex;
  padding: 30px 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.rectangle {
  overflow: hidden;
}

.rectangle.large {
  margin: 0 0 30px 4%;
  width: 44%;
  box-shadow: 0 .533vw 3.2vw 0 rgba(0, 0, 0, .1);
  border-radius: 10px;
}

.rectangle .wrapper {
  position: relative;
  padding: 0 10px;
}

.rectangle .wrapper .content {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.rectangle.large .wrapper {
  padding: 70px 100px;
}

.rectangle .wrapper .content .name-text.large {
  font-size: 30px;
}

.rectangle .wrapper .content .name-text {
  color: #7d7c7c;
}

.rectangle .wrapper .content .odd-text.large {
  font-size: 25px;
  margin-top: -30px;
}

.rectangle .wrapper .content .odd-text {
  text-align: center;
  color: #ff253f;
}

.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  z-index: 2;
}

.bottom-bar .bar .left, .bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 #cacaca;
  z-index: 2;
}

.bottom-bar .bar .left, .bottom-bar .bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bottom-bar .bar .left .item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 20px;
}

.bottom-bar .bar .left .item .text {
  font-size: 22px;
  color: #7d7c7c;
}

.jixuanico {
  font-size: 45px;
}

.bottom-bar .bar .left .line {
  width: 2px;
  height: 50px;
  background: #dadada;
}

.bottom-bar .bar .mid {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.bottom-bar .bar .mid .text {
  font-size: 30px;
  font-weight: 500;
}

.bottom-bar .bar .mid .text.num {
  margin: 0 5px;
  color: #ff253f;
}

.bottom-bar .bar .right {
  padding: 0 30px;
  margin: 0 30px;
  color: #fff;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  font-size: 40px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 50px;
}

.rectangle.active .wrapper {
  background-color: #e6c3a1 !important;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-popup {
  position: absolute;
}

::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}

::v-deep .van-popup--top {
  top: -1px;
}

.wrapper .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.wrapper .item .left {
  width: 35%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: #000;
}

.font-weight {
  font-weight: 700 !important;
}

.wrapper .item .right {
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: #000;
}

.wrapper .item .kuaisan-ball .left {
  justify-content: flex-start;
}

.wrapper .item .kuaisan-ball {
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}

.wrapper .item .kuaisan-ball .res-img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.wrapper .item .kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
}

.wrapper .item .kuaisan-ball .res-des.middle {
  //width: 15%;
  padding: 0 10px;
  font-size: 28px;
}

.play-type-tip {
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}

.play-type-tip .title {
  line-height: 90px;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}

.mask {
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}

.play-type-tip .wrapper {
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.play-type-tip .wrapper .item {
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}

.play-type-tip .wrapper .item .van-icon {
  color: #e6c3a1;
  font-size: 60px;
}

.play-type-tip .wrapper .item .content .content-title {
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: #000;
  line-height: 0px;
}

.play-type-tip .wrapper .item .content .content-detail {
  margin-top: 5px;
  font-size: 22px;
  color: #000;
  line-height: 30px;
}

.play-type-tip .wrapper .item .content {
  flex: 1;
  margin-left: 30px;
}

.rectangle.active .wrapper {
  background-color: #f82d46 !important;
}

.rectangle.active .wrapper .name-text, .rectangle.active .wrapper .odd-text {
  color: #fff !important;
}

.bottom-bar .wrapper {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 230px;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 10px 0 #cacaca;
  transition: transform .3s cubic-bezier(.21, 1.02, .55, 1.01);
}

.bottom-bar .wrapper.active {
  transform: translateY(-100%);
}

.bottom-bar .wrapper .item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
}

.bottom-bar .wrapper .item .label {
  font-size: 30px;
  line-height: 30px;
  color: #000;
}

.bottom-bar .wrapper .item .bet-number {
  flex: 1;
  margin: 0 16px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #ff253f;
  font-size: 30px;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
}

.bottom-bar .wrapper .item .amount-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.van-cell {
  font-size: 30px;
  line-height: 50px;
}

.bottom-bar .wrapper .item .part {
  margin-right: 20px;
}

.bottom-bar .wrapper .item .part span {
  font-size: 30px;
  vertical-align: center;
  color: #000;
}

.bottom-bar .wrapper .item .part .number {
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}

::v-deep .van-field__control {
  color: #ff253f;
}

.confirm-order-modal {
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 30px;
}

.confirm-order-modal .head {
  position: relative;
  height: 80px;
}

.confirm-order-modal .head .text {
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}

::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}

.van-popup--center {
  border-radius: 30px;
}

.confirm-order-modal .list {
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}

.confirm-order-modal .list .lise-item .main {
  flex: 1;
  overflow: hidden;
}

.confirm-order-modal .list .lise-item .main .bet-name {
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}

.confirm-order-modal .list .lise-item .main .detail-text {
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}

.confirm-order-modal .list .lise-item {
  color: #ff253f;
}

.confirm-order-modal .sub-bar {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}

.confirm-order-modal .sub-bar .item {
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}

.confirm-order-modal .sub-bar .item.cancel-btn {
  border: 2px solid #979799;
  color: #979799;
  background-color: #fff;
}

.confirm-order-modal .sub-bar .item.sub-btn {
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  color: #fff;
  border: 0;
}

.next-number span {
  font-size: 35px;
  font-weight: 700;
  color: #fff;
  float: right;
}

.recent-card {
  display: flex;
  justify-content: space-between;
  background-color: #eaa07b;
  padding: 30px 20px;
  border-radius: 20px
}

.mid-num-wrapper .numCard:first-child {
  margin-bottom: 5px;
}
.mid-num-wrapper {
  flex: 1;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sum {
  width: 52px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  color: #fff;
  border-radius: 50%;
  background-color: #eaa07b;
}

.text-wrapper {
  padding: 8px 8px;
  font-weight: bold;
  border-radius: 8px;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  .nav-bar .right {
    padding-left: 5px; /* 8px * 0.5733 ≈ 5px */
    padding-right: 5px; /* 8px * 0.5733 ≈ 5px */
    font-size: 16px; /* 28px * 0.5733 ≈ 16px */
    border-radius: 6px; /* 10px * 0.5733 ≈ 6px */
    border: 1px solid #fff; /* 2px * 0.5733 ≈ 1px */
    line-height: 34px; /* 60px * 0.5733 ≈ 34px */
  }

  // 记录区域PC端适配
  .record {
    padding-left: 12px; /* 2.667vw * 0.5733 ≈ 12px */
    padding-right: 12px; /* 2.667vw * 0.5733 ≈ 12px */
    padding-bottom: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .record .period {
    padding: 11px 0; /* 20px * 0.5733 ≈ 11px */
  }

  .record .period .cover {
    width: 69px; /* 120px * 0.5733 ≈ 69px */
    height: 69px; /* 120px * 0.5733 ≈ 69px */
  }

  .record .period .period-number {
    margin-left: 11px; /* 20px * 0.5733 ≈ 11px */
    margin-right: 6px; /* 10px * 0.5733 ≈ 6px */
    height: 29px; /* 50px * 0.5733 ≈ 29px */
    line-height: 29px; /* 50px * 0.5733 ≈ 29px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .carouselAds {
    max-height: 172px;
    .swiper-slide{
      width: 400px;
      height: 172px;
    }
  }

  .period-number {
    margin-left: 11px; /* 20px * 0.5733 ≈ 11px */
    margin-right: 6px; /* 10px * 0.5733 ≈ 6px */
    height: 29px; /* 50px * 0.5733 ≈ 29px */
    line-height: 29px; /* 50px * 0.5733 ≈ 29px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .van-count-down {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
    // margin-top: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  .kuaisan-ball .res-img {
    width: 40px; /* 70px * 0.5733 ≈ 40px */
    height: 40px; /* 70px * 0.5733 ≈ 40px */
    margin-right: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .kuaisan-ball .res-des {
    height: 40px; /* 7vw * 0.5733 ≈ 40px */
    line-height: 40px; /* 7vw * 0.5733 ≈ 40px */
    font-size: 17px; /* 3vw * 0.5733 ≈ 17px */
    margin-right: 23px; /* 4vw * 0.5733 ≈ 23px */
    border-radius: 5px;
  }

  .numCard-wrapper {
    width: 60%;
    border-radius: 11px; /* 20px * 0.5733 ≈ 11px */
    padding: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .numCard {
    font-size: 20px; /* 4.667vw * 0.5733 ≈ 27px */
    height: 40px; /* 7vw * 0.5733 ≈ 40px */
    line-height: 40px; /* 7vw * 0.5733 ≈ 40px */
    border-radius: 5px; /* 1.333vw * 0.5733 ≈ 1px */
  }

  .numCard1 {
    width: 46px; /* 80px * 0.5733 ≈ 46px */
    height: 46px; /* 80px * 0.5733 ≈ 46px */
    line-height: 46px; /* 80px * 0.5733 ≈ 46px */
    border-radius: 50%;
  }

  .kuaisan-ball .res-des.middle {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .van-icon {
    font-size: 23px; /* 40px * 0.5733 ≈ 23px */
  }

  .recent-card {
    padding: 17px 11px; /* 30px * 0.5733 ≈ 17px, 20px * 0.5733 ≈ 11px */
    border-radius: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .sum {
    width: 30px; /* 52px * 0.5733 ≈ 30px */
    height: 30px; /* 52px * 0.5733 ≈ 30px */
    line-height: 30px; /* 52px * 0.5733 ≈ 30px */
  }

  // 选项栏PC端适配
  .options-bar {
    height: calc(100% - 46px); /* 80px * 0.5733 ≈ 46px */
  }

  .options-bar .game .tips {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
    padding: 0 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .options-bar .game .tips .odds {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  ::v-deep .van-icon-more-o {
    font-size: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  .options-bar .game .tips .play-tip .span-text {
    margin-left: 6px; /* 10px * 0.5733 ≈ 6px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .sumValueTwoSides {
    padding: 17px 0; /* 30px * 0.5733 ≈ 17px */
  }

  .rectangle.large {
    margin: 0 0 17px 4%; /* 30px * 0.5733 ≈ 17px */
    width: 44%;
    border-radius: 6px; /* 10px * 0.5733 ≈ 6px */
  }

  .rectangle.large .wrapper {
    padding: 40px 57px; /* 70px * 0.5733 ≈ 40px, 100px * 0.5733 ≈ 57px */
  }

  .rectangle .wrapper .content .name-text.large {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .rectangle .wrapper .content .odd-text.large {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
    margin-top: -17px; /* -30px * 0.5733 ≈ -17px */
  }

  // 底部栏PC端适配
  .bottom-bar {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  .bottom-bar .bar {
    height: 57px; /* 100px * 0.5733 ≈ 57px */
  }

  .bottom-bar .bar .left .item {
    width: 57px; /* 100px * 0.5733 ≈ 57px */
    font-size: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .bottom-bar .bar .left .item .text {
    font-size: 13px; /* 22px * 0.5733 ≈ 13px */
  }

  .jixuanico {
    font-size: 26px; /* 45px * 0.5733 ≈ 26px */
  }

  .bottom-bar .bar .left .line {
    width: 1px; /* 2px * 0.5733 ≈ 1px */
    height: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  .bottom-bar .bar .mid .text {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .bottom-bar .bar .right {
    padding: 0 17px; /* 30px * 0.5733 ≈ 17px */
    margin: 0 17px; /* 30px * 0.5733 ≈ 17px */
    font-size: 23px; /* 40px * 0.5733 ≈ 23px */
    height: 40px; /* 70px * 0.5733 ≈ 40px */
    line-height: 40px; /* 70px * 0.5733 ≈ 40px */
    border-radius: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  .bottom-bar .wrapper {
    top: 6px; /* 10px * 0.5733 ≈ 6px */
    padding: 11px; /* 20px * 0.5733 ≈ 11px */
    height: 132px; /* 230px * 0.5733 ≈ 132px */
  }

  .bottom-bar .wrapper .item {
    height: 37px; /* 65px * 0.5733 ≈ 37px */
  }

  .bottom-bar .wrapper .item .label {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
    line-height: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .bottom-bar .wrapper .item .bet-number {
    margin: 0 9px; /* 16px * 0.5733 ≈ 9px */
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
    height: 23px; /* 40px * 0.5733 ≈ 23px */
    line-height: 23px; /* 40px * 0.5733 ≈ 23px */
  }

  .van-cell {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
    line-height: 29px; /* 50px * 0.5733 ≈ 29px */
  }

  .bottom-bar .wrapper .item .part {
    margin-right: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .bottom-bar .wrapper .item .part span {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  // 弹窗PC端适配
  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .wrapper .item {
    padding: 6px 0; /* 10px * 0.5733 ≈ 6px */
  }

  .wrapper .item .left {
    width: 35%;
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .wrapper .item .right {
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .wrapper .item .kuaisan-ball {
    margin-left: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .wrapper .item .kuaisan-ball .res-img {
    width: 29px; /* 50px * 0.5733 ≈ 29px */
    height: 29px; /* 50px * 0.5733 ≈ 29px */
    margin-right: 11px; /* 20px * 0.5733 ≈ 11px */
  }

  .wrapper .item .kuaisan-ball .res-des.middle {
    padding: 0 6px; /* 10px * 0.5733 ≈ 6px */
    font-size: 16px; /* 28px * 0.5733 ≈ 16px */
  }

  .play-type-tip {
    width: 373px; /* 650px * 0.5733 ≈ 373px */
    height: 401px; /* 700px * 0.5733 ≈ 401px */
    border-radius: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .play-type-tip .title {
    line-height: 52px; /* 90px * 0.5733 ≈ 52px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .play-type-tip .wrapper .item {
    padding: 23px 29px; /* 40px * 0.5733 ≈ 23px, 50px * 0.5733 ≈ 29px */
  }

  .play-type-tip .wrapper .item .van-icon {
    font-size: 34px; /* 60px * 0.5733 ≈ 34px */
  }

  .play-type-tip .wrapper .item .content .content-title {
    margin-top: 13px; /* 22px * 0.5733 ≈ 13px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .play-type-tip .wrapper .item .content .content-detail {
    margin-top: 3px; /* 5px * 0.5733 ≈ 3px */
    font-size: 13px; /* 22px * 0.5733 ≈ 13px */
    line-height: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .play-type-tip .wrapper .item .content {
    margin-left: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .confirm-order-modal {
    padding: 0 11px 17px; /* 20px * 0.5733 ≈ 11px, 30px * 0.5733 ≈ 17px */
    width: 350px; /* 610px * 0.5733 ≈ 350px */
    height: 390px; /* 680px * 0.5733 ≈ 390px */
    border-radius: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .confirm-order-modal .head {
    height: 46px; /* 80px * 0.5733 ≈ 46px */
  }

  .confirm-order-modal .head .text {
    padding: 0 11px; /* 20px * 0.5733 ≈ 11px */
    height: 17px; /* 30px * 0.5733 ≈ 17px */
    line-height: 6px; /* 10px * 0.5733 ≈ 6px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .confirm-order-modal .list {
    padding: 0 6px; /* 10px * 0.5733 ≈ 6px */
  }

  .confirm-order-modal .list .lise-item {
    padding: 6px 0; /* 10px * 0.5733 ≈ 6px */
  }

  .confirm-order-modal .list .lise-item .main .bet-name {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .confirm-order-modal .list .lise-item .main .detail-text {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .confirm-order-modal .sub-bar {
    margin-top: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .confirm-order-modal .sub-bar .item {
    min-width: 40%;
    height: 46px; /* 80px * 0.5733 ≈ 46px */
    border-radius: 29px; /* 50px * 0.5733 ≈ 29px */
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .confirm-order-modal .sub-bar .item.cancel-btn {
    border: 1px solid #979799; /* 2px * 0.5733 ≈ 1px */
  }

  .next-number span {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .text-wrapper {
    padding: 5px 5px; /* 8px * 0.5733 ≈ 5px */
    border-radius: 5px; /* 8px * 0.5733 ≈ 5px */
  }
  .van-popup--center{
    border-radius: 17px;
  }

  .period-number,.next-number {
    gap: 8px;
  }
  .period-number div:first-child,.next-number span {
    font-size: 20px !important;
  }
}
</style>
